module.exports = __webpack_public_path__ + "static/media/Products (2).0978681a.jpeg";